import { FormType, IFormResponse } from '../types'

export class FormUtils {
  public static isAuthRequired(form: Pick<IFormResponse, 'type'>) {
    return form.type !== FormType.Specialist
  }
}
